export interface SheetContent {
  id: number;
  sheetName: string;
  visibility: string;
  content1: string | null;
  content2: string | null;
  content3: string | null;
  content4: string | null;
  content5: string | null;
  status: number;
  createdBy: number;
  createdByName: string | null;
  createdAt: string;
  updatedAt: string;
}

export interface AppDocument {
  id: number;
  documentName: string;
  documentType: string;
  originalFileName: string;
  storedFileName: string;
  filePath: string;
  fileExtension: string;
  fileSize: number;
  uploadedBy: number;
  uploadedByName: string | null;
  status: number;
  createdAt: string;
  updatedAt: string;
}

export interface SheetPayload {
  id?: number;
  sheetName: string;
  visibility: 'ALL' | 'PRIVATE';
  content1: string | null;
  content2: string | null;
  content3: string | null;
  content4: string | null;
  content5: string | null;
}

export const MAX_SHEET_PAGES = 5;

export const DOCUMENT_TYPES: ReadonlyArray<{ value: string; label: string }> = [
  { value: 'SIMPLE_DOCUMENT', label: 'Simple Document' },
  ...Array.from({ length: 9 }, (_, i) => ({ value: `TEMPLATE_${i + 1}`, label: `Template ${i + 1}` })),
];

export const documentTypeLabel = (value: string): string =>
  DOCUMENT_TYPES.find((t) => t.value === value)?.label ?? value;

export const visibilityLabel = (v: string): string => (v === 'PRIVATE' ? 'Private' : 'Public');

/** Non-empty content1..5 pages, in order. */
export function sheetPages(s: Pick<SheetContent, 'content1' | 'content2' | 'content3' | 'content4' | 'content5'>): string[] {
  return [s.content1, s.content2, s.content3, s.content4, s.content5].filter(
    (c): c is string => typeof c === 'string' && c.trim() !== '',
  );
}

export function formatFileSize(bytes: number): string {
  if (bytes >= 1024 * 1024) return `${(bytes / 1024 / 1024).toFixed(1)} MB`;
  return `${Math.max(1, Math.round(bytes / 1024))} KB`;
}
